import PageTitle from '../components/layout/PageTitle';
import { PageContent } from '../components/layout/style';

export default function AboutPage() {
    return <PageContent>
        <PageTitle title='О проекте'/>
        <p>
            Тут все просто - однажды я приобрел себе гусли и не нашел нормально оформленных уроков
            (аккордов, в частности).
        </p>

        <p>
            Так вышло, что при разработке проекта скорее преследовались технические задачи, чем содержательные.
            Проекту требуются участники: музыканты, преподаватели - в целом, люди готовые делиться знаниями именно как гусляры.
        </p>

        <p>То, что представлено здесь - скорее, платформа (или её прототип). Получит ли она развитие - зависит от её пользователей, энтузиастов</p>

        <p>
            Так что, если у вас возникли пожелания, предложения или вы нашли ошибку, напишите <a
            href='mailto:alx.devel@gmail.com'>сюда</a>&nbsp;
            или <a href='https://vk.com/aklimenkov' target='_blank' rel='noopener noreferrer'>сюда</a>
        </p>

        <p>
            Поддержать проект можно и финансово
        </p>

        <div>
            <iframe
                src="https://money.yandex.ru/quickpay/button-widget?targets=%D0%9F%D0%BE%D0%B6%D0%B5%D1%80%D1%82%D0%B2%D0%BE%D0%B2%D0%B0%D1%82%D1%8C%20ruharp&default-sum=50&button-text=14&any-card-payment-type=on&button-size=s&button-color=orange&successURL=&quickpay=small&account=41001355856956&"
                width="200" height="25" frameBorder="0" allowTransparency="true" scrolling="no"></iframe>
        </div>
    </PageContent>
}
